export function mapByTargets(submission, form) {
    return mapBy(submission, form, 'target');
}
export function mapByIds(submission, form) {
    return mapBy(submission, form, 'id');
}
function mapBy(submission, form, by) {
    const from = by === 'id' ? 'target' : 'id';
    const fields = form?.fields ?? [];
    return fields.reduce((acc, field) => {
        const source = field[from];
        const destination = field[by];
        if (source &&
            destination &&
            source !== destination &&
            acc.hasOwnProperty(source)) {
            acc[destination] = acc[source];
            const { [source]: omitted, ...rest } = acc;
            acc = rest;
        }
        return acc;
    }, { ...submission });
}
//# sourceMappingURL=submission-mapper.js.map